import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Section, SectionHeader } from "@/components/marketing/Section";
import { Button } from "@/components/ui/Button";
import { BRAND_NAME } from "@/lib/brand";
import { appUrl, env } from "@/lib/env";
import { preserveSearch } from "@/lib/nav";

export function About() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const referralCode = new URLSearchParams(search).get("ref");

  return (
    <Section className="pt-12">
      <SectionHeader pageTitle title={t("about.title")} subtitle={t("about.subtitle")} />

      {/* Why we exist — advances the subtitle's premise, doesn't restate it. */}
      <div className="mt-14 flex max-w-2xl flex-col gap-4">
        <h2 className="font-sans text-2xl font-semibold tracking-tight text-foreground">
          {t("about.missionTitle")}
        </h2>
        <p className="leading-relaxed text-muted-foreground">
          {BRAND_NAME} is a trading agent we build and run ourselves — not a chatbot bolted onto a
          brokerage. The gap we're closing isn't capability; it's the trust to hand one real
          decisions.
        </p>
        <p className="leading-relaxed text-muted-foreground">
          So we make the agent's process visible, gated, and auditable — you supervise a competent
          analyst instead of gambling on a confident one. That conviction runs through everything we
          build.
        </p>
      </div>

      {/* Who we are — a collective statement, no per-person bios. */}
      <div className="mt-16">
        <div className="rounded-card border border-border bg-card p-8 sm:p-10">
          <h2 className="font-sans text-2xl font-semibold tracking-tight text-foreground">
            {t("about.teamTitle")}
          </h2>
          <p className="mt-5 max-w-3xl text-pretty text-lg font-medium leading-relaxed text-foreground">
            {t("about.teamLead")}
          </p>
          <p className="mt-4 max-w-3xl leading-relaxed text-muted-foreground">
            {t("about.teamBody")}
          </p>
        </div>
      </div>

      <div className="mt-16 flex flex-wrap items-center gap-3">
        {env.launched ? (
          <Button
            variant="primary"
            href={appUrl("/sign-in", referralCode)}
            trailing={<ArrowRight className="h-4 w-4" aria-hidden />}
          >
            {t("nav.signIn")}
          </Button>
        ) : (
          <Button
            variant="primary"
            to={preserveSearch("/#waitlist", search)}
            trailing={<ArrowRight className="h-4 w-4" aria-hidden />}
          >
            {t("nav.joinWaitlist")}
          </Button>
        )}
      </div>
    </Section>
  );
}
